import Mutations from '../../odata/mutations';

export default { ...new Mutations('factoryItem'), ...new Mutations('factoryItems') };
